import React, { FC, useEffect, useState } from "react";
import { PDFViewer, PDFViewerTool } from "@progress/kendo-react-pdf-viewer";

// import style from "../utils/style.module.css";
import { getPdfApi } from "api/pdf";

const tools: PDFViewerTool[] = [
	"pager",
	"spacer",
	"zoomInOut",
	"zoom",
	"selection",
	"spacer",
	"search",
	//"open",
	"download",
	"print",
];

export const PdfViewer: FC<{ reportGuid: string }> = ({ reportGuid }) => {
	const [pdfData, setPdfData] = useState<string>();

	useEffect(() => {
		getPdfApi(reportGuid)
			.then((response) => {
				setPdfData(response);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	return (
		<div style={{ maxHeight: "95%" }}>
			<PDFViewer data={pdfData} style={{ height: "96%" }} tools={tools} />
		</div>
	);
};

export default PdfViewer;
